import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { Button } from 'rebass'

const ContactButton = props => (
  <Button
    is={AnchorLink}
    href="#contact"
    bg="#222020"
    fontSize={[2, 3, 4]}
    borderRadius={0}
  >
    CONTACT
  </Button>
)

export default ContactButton



// WEBPACK FOOTER //
// ./src/containers/Hero/ContactButton.js